/**
 * Nested menu tools.
 */
H_Tools.nestedmenu = (() => {
    // console.log('Nested menu tools initialized...');

    /**
     * Shows menu item children <li class="menu-item-has-children">
     *
     * @param {*} menu A menu
     * @param {*} li   A menu item
     */
    function activateMenuItem(menu, li) {
        // console.log('Activating menu item');

        if (!li) {
            return;
        }

        const ul = li.children[1];
        if (ul) {
            li.classList.add('-open');

            let caret = getMenuItemCaret(li);
            if (caret) {
                caret.classList.add('-open');
                caret.setAttribute('aria-expanded', 'true');
            }

            ul.classList.add('-open');
            li.dispatchEvent(new Event('submenuopened'));
        }

        // activate parents <li> + <ul>
        const ancestors = H_Tools.ancestors.getAllAncestors(
            li,
            menu,
            'menu-item-has-children'
        );
        for (let i = 0; i < ancestors.length; i++) {
            activateMenuItem(menu, ancestors[i]);
        }
    }

    /**
     * Hides menu item children <li class="menu-item-has-children">
     *
     * @param {*} li A menu item
     */
    function deactivateMenuItem(li) {
        // console.log('Deactivating menu item');

        // validate
        if (!li) {
            return;
        }

        li.classList.remove('-is-clicked');

        // deactivate <ul>
        const ul = li.children[1];
        if (ul) {
            li.classList.remove('-open');

            let caret = getMenuItemCaret(li);
            if (caret) {
                caret.classList.remove('-open');
                caret.setAttribute('aria-expanded', 'false');
            }

            ul.classList.remove('-open');
            ul.classList.remove('-is-out-of-bounds-right');
            ul.classList.remove('-is-out-of-bounds-bottom');
            ul.classList.remove('-is-out-of-bounds-top-and-bottom');
        }

        // deactivate children <li> + <ul>
        const children = li.querySelectorAll('.menu-item-has-children');
        for (let i = 0; i < children.length; i++) {
            deactivateMenuItem(children[i]);
        }
    }

    /**
     * Returns the caret element from the supplied menu item.
     *
     * @param {*} li A menu item
     */
    function getMenuItemCaret(li) {
        return li.children[0].children[1].children[0];
    }

    /**
     * Checks if the supplied menu item is on cooldown.
     *
     * "Cooldown" means that the menu item is (figuratively) too hot to touch for a while. This can
     * be used to prevent spamming the activation of the menu item.
     *
     * The cooldown state is stored in an expando property of the menu item element.
     *
     * @see https://developer.mozilla.org/en-US/docs/Glossary/Expando
     * @see startCooldown - A function to start a cooldown on a menu item
     *
     * @param {*} li A menu item
     */
    function isOnCooldown(li) {
        return li.cooldown;
    }

    /**
     * Reset all menu-items' state.
     *
     * @param {*} menu A menu
     */
    function resetMenuItems(menu) {
        const items_with_children = menu.querySelectorAll(
            '.menu-item-has-children'
        );
        for (let i = 0; i < items_with_children.length; i++) {
            deactivateMenuItem(items_with_children[i]);
        }
    }

    /**
     * Starts a cooldown on the supplied menu item.
     *
     * "Cooldown" means that the menu item is (figuratively) too hot to touch for a while. This can
     * be used to prevent spamming the activation of the menu item.
     *
     * The cooldown state is stored in an expando property of the menu item element.
     *
     * @see https://developer.mozilla.org/en-US/docs/Glossary/Expando
     * @see isOnCooldown - A function to check the cooldown state of a menu item
     *
     * @param {*} li             A menu item
     * @param {*} cooldownMillis (Optional) A cooldown duration in milliseconds - Default is 400
     */
    function startCooldown(li, cooldownMillis = 400) {
        li.cooldown = true;
        setTimeout(
            function (li) {
                li.cooldown = false;
            },
            cooldownMillis,
            li
        );
    }

    /**
     * Toggles the supplied menu item.
     *
     * @return {int} An integer value indicating the result of the toggle, where
     *               - `-1` = closed
     *               - `0` = failure
     *               - `1` = opened
     */
    function toggleMenuItem(menu, li) {
        // console.log('Toggling menu item');

        if (!li) {
            return 0;
        }

        if (li.classList.contains('-open')) {
            deactivateMenuItem(li);
            return -1;
        } else {
            activateMenuItem(menu, li);
            return 1;
        }
    }

    // return an object to expose inner functions
    return {
        activateMenuItem: activateMenuItem,
        deactivateMenuItem: deactivateMenuItem,
        isOnCooldown: isOnCooldown,
        resetMenuItems: resetMenuItems,
        startCooldown: startCooldown,
        toggleMenuItem: toggleMenuItem,
    };
})();
